import React from 'react';
import { motion } from 'framer-motion';
import { FloatingElements } from './FloatingElements';
export function TruthSection() {
  return <section className="bg-dark py-20 md:py-32 px-5 relative overflow-hidden" data-id="element-341">
      <div className="absolute inset-0 bg-radial-money" aria-hidden="true" data-id="element-342" />
      <FloatingElements count={8} variant="money" data-id="element-343" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-344">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true,
        margin: '-80px'
      }} data-id="element-345">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-white/80 mb-4" data-id="element-346">
            La verdad{' '}
            <span className="font-serif italic font-normal text-white/50" data-id="element-347">
              (un poco incómoda)
            </span>
          </h2>
          <p className="font-sans text-white/50 text-lg mb-10" data-id="element-348">
            Tu hijo no necesita una lección de finanzas. Necesita un sistema
            visible que responda una sola pregunta:
          </p>
        </motion.div>

        <motion.div className="relative" initial={{
        opacity: 0,
        scale: 0.92
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.15
      }} viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-349">
          <div className="absolute inset-0 bg-radial-money rounded-2xl" aria-hidden="true" data-id="element-350" />
          <blockquote className="relative border border-money/25 rounded-2xl px-8 py-10 md:px-12 md:py-14 money-glow" data-id="element-351">
            <p className="font-display text-3xl sm:text-4xl md:text-5xl font-extrabold text-gradient-money leading-tight" data-id="element-352">
              «¿Qué hacemos con el dinero en esta casa?»
            </p>
          </blockquote>
        </motion.div>
      </div>
    </section>;
}